export const logModel = {
   'created_at': {
      'title': "Date",
      'display': true
   },
   'user': {
      'title': "User",
      'display': true
   },
   'user_id': {
      'title': "User ID",
      'display': false
   },
   'app': {
      'title': "Application",
      'display': true
   },
   'severity': {
      'title': "Severity",
      'display': true
   },
   'message': {
      'title': "Message",
      'display': true
   }
};